import React from 'react';
import _ from 'lodash';
import {Input, Radio, Dropdown, Grid, GridColumn} from 'semantic-ui-react';

export class SortList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: 'ascending',
    };
  }

  handleDirectionChange(value) {
    this.setState({value: value});
    this.props.onSortDirectionChange(value);
  }

  handleColumnChange = (event, {value}) => {
    this.props.onSortColumnChange(value);
  };

  render() {
    const {attributes, trackSubGrants} = this.props;
    const options = [
      {text: 'ID', value: 'key'},
      {text: 'Attribute', value: 'attribute', attributeName: 'foTrackFundingTarget'},
      {
        text: trackSubGrants ? 'Suborganization Type' : 'Organization Type',
        value: 'organizationInfo',
        attributeName: 'organizationKind',
      },
      {
        text: trackSubGrants ? 'Suborganization Name' : 'Organization Name',
        value: 'organizationName',
      },
      {text: 'State', value: 'orgState'},
      {text: 'Milestone', value: 'state'},
      {text: 'Cumulative score', value: 'score'},
      {text: 'Priority rank', value: 'rank'},
      {text: 'Fed share', value: 'value'},
    ];

    const filteredOptions = _.filter(options, (option) => {
      return !option.attributeName || _.includes(attributes, option.attributeName);
    });

    return (
      <React.Fragment>
        <div className="setAsideColumn">
          <Dropdown
            options={filteredOptions}
            defaultValue="rank"
            title="Sort by:"
            selection
            onChange={this.handleColumnChange}
            className="column"
            basic
          />
        </div>
        <div className="setAsideColumn">
          <Radio
            name="sort"
            value="ascending"
            label="Ascending"
            title="Ascending"
            checked={this.state.value === 'ascending'}
            onChange={() => this.handleDirectionChange('ascending')}
          />
        </div>
        <div className="setAsideColumn">
          <Radio
            name="sort"
            value="descending"
            label="Descending"
            title="Descending"
            checked={this.state.value === 'descending'}
            onChange={() => this.handleDirectionChange('descending')}
          />
        </div>
      </React.Fragment>
    );
  }
}
